import React, { useState } from 'react';
import { Box, Button, Typography } from '@mui/material';
import { styles } from '../assets/styles';
import { ShareBox } from './containers';

export function ShareResultsClassic() {
  const [copied, setCopied] = useState(false);
  const squareColors = JSON.parse(localStorage.getItem('square_colors')).flat();
  const fetchCount = JSON.parse(localStorage.getItem('fetch_count'));
  const hasWonToday = localStorage.getItem('has_won');
  const tryText = fetchCount === 1 ? 'try' : 'tries';

  const colorsWithEmojis = squareColors.map((color) => {
    switch (color) {
      case '#ffa1b0':
        return '🟥';
      case '#ffe49c':
        return '🟨';
      case '#a4ff91':
        return '🟩';
    }
  });

  const emojiTable = [];
  for (let i = 0; i < colorsWithEmojis.length; i += 5) {
    emojiTable.push(`${colorsWithEmojis.slice(i, i + 5).join('')}\n`);
  }

  const copyText = `I guessed #pikadle random POKéMON in classic mode in ${fetchCount} ${tryText}! 🎉🎉🎉\n`;
  const reversedEmojiTable = emojiTable.reverse();
  const maxRows = 10; // Máximo número de filas a mostrar
  const remainingRows = Math.max(0, emojiTable.length - maxRows); // Número de filas restantes

  const displayedEmojiTable = emojiTable.slice(0, maxRows); // Filas a mostrar

  const emojiTableContent = displayedEmojiTable.map((row) => `${row.trim()}\n`).join('');

  const tableText = remainingRows > 0 ? `  + and ${remainingRows} more!` : ''; // Mensaje para filas restantes

  const copyTable = `\n\u200E${emojiTableContent}${tableText}`;

  const copyLink = '\nhttps://pikadle.vercel.app';

  const copyToClipboard = () => {
    navigator.clipboard.writeText(copyText + copyTable + copyLink);
    setCopied(true);
  };

  return (
    <>
      {hasWonToday && (
        <ShareBox>
          <Box sx={styles.copyText2}>
            <Typography sx={styles.copyTypography1}>{copyText}</Typography>
          </Box>

          <Box sx={styles.copySquares}>
            <pre style={styles.pre}>{copyTable}</pre>
          </Box>

          <Box sx={styles.copyWebsite}>
            <Typography sx={styles.copyTypography2}>https://pikadle.vercel.app</Typography>
          </Box>

          <Box sx={styles.copyContainer}>
            <Button disableRipple onClick={copyToClipboard} sx={styles.copyButton}>
              {copied ? 'Copied' : 'Copy'}
            </Button>
          </Box>
        </ShareBox>
      )}
    </>
  );
}

export function ShareResultsCopy({ fetchCountKey, hasWonTodayKey, copyTextPrefix }) {
  const [copied, setCopied] = useState(false);
  const fetchCount = JSON.parse(localStorage.getItem(fetchCountKey));
  const hasWonToday = localStorage.getItem(hasWonTodayKey);
  const tryText = fetchCount === 1 ? 'try' : 'tries';

  const copyText = `${copyTextPrefix}${fetchCount} ${tryText}! 🎉🎉🎉\n`;
  const copyLink = '\nhttps://pikadle.vercel.app';

  const copyToClipboard = () => {
    navigator.clipboard.writeText(copyText + copyLink);
    setCopied(true);
  };

  return (
    <>
      {hasWonToday && (
        <ShareBox>
          <Box sx={styles.copyText}>
            <Typography sx={styles.copyTypography1}>{copyText}</Typography>
          </Box>

          <Box sx={styles.copyWebsite}>
            <Typography sx={styles.copyTypography2}>https://pikadle.vercel.app</Typography>
          </Box>

          <Box sx={styles.copyContainer}>
            <Button disableRipple onClick={copyToClipboard} sx={styles.copyButton}>
              {copied ? 'Copied' : 'Copy'}
            </Button>
          </Box>
        </ShareBox>
      )}
    </>
  );
}

export function ShareResultsCopyCries() {
  return (
    <ShareResultsCopy
      fetchCountKey="fetch_count_cries"
      hasWonTodayKey="has_won_cries"
      copyTextPrefix="I guessed #pikadle random POKéMON cry in "
    />
  );
}

export function ShareResultsCopyEmoji() {
  return (
    <ShareResultsCopy
      fetchCountKey="fetch_count_emoji"
      hasWonTodayKey="has_won_emoji"
      copyTextPrefix="I guessed #pikadle random POKéMON with emojis "
    />
  );
}
